import { ApolloClient, gql, NormalizedCacheObject } from "@apollo/client";
import { Query } from "../types/generated/graphql";
import DataLoader from 'dataloader';
import _ from "lodash";

type T = Pick<Query, 'getCachedVideos'>;
export const QUERY_GET_CACHED_VIDEO = gql`
  query fct($videoIds: [String!]!) {
    getCachedVideos(videoIds: $videoIds) {
      id
      author {
        id
        name
        thumbnails {
          height
          url
          width
        }
      }
      thumbnails {
        height
        url
        width
      }
      title
    }
  }
`;

const loader = (client: ApolloClient<NormalizedCacheObject>) => {
  return new DataLoader(async (keys) => {
    // Make the GraphQL request with all the IDs
    const { data } = await client.query<T>({
      query: QUERY_GET_CACHED_VIDEO,
      variables: { videoIds: keys },
    });
  
    // Map the response data back to the loader keys
    const resultMap = data.getCachedVideos.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {} as Record<string, T['getCachedVideos'][number]>);
  
    // Return the data in the order of the original keys
    return keys.map((id) => resultMap[id as string]);
  }, {
    maxBatchSize: 30
  });
};

export const createCachedVideosLoader = _.memoize(loader);